import { Category } from "./views/Category/Category";
import { DataContext } from "./context/DataContext";
import { Header } from "./components/Header/Header";
import { Home } from "./views/Home/Home";
import { initReactI18next } from "react-i18next";
import { NotFound } from "./views/NotFound/NotFound";
import { Page } from "./views/Page/Page";
import { Project } from "./views/Project/Project";
import { useLocation, BrowserRouter, Routes, Route } from "react-router-dom";
import DataProvider from "./context/DataContext";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import VideoProvider from "./context/VideoContext";
import it from "./translations/it.json";
import en from "./translations/en.json";
import "./common/reset.scss";
import "./common/variables.scss";
import "./common/typography.scss";

ReactGA.initialize(process.env.REACT_APP_GA4_ID || "G-XXXXXXXXXX");

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: {
			order: [
				"cookie",
				"localStorage",
				"path",
				"navigator",
				"htmlTag",
				"subdomain",
			],
			lookupCookie: "qtrans_front_language",
			convertDetectedLanguage: (lng) => lng.split("-")[0],
		},
		resources: {
			it: {
				translation: it,
			},
			en: {
				translation: en,
			},
		},
		fallbackLng: "it",
		interpolation: {
			escapeValue: false,
		},
	});

const App = () => {
	const fullPageRef = React.useRef();
	const location = useLocation();
	const { languages } = React.useContext(DataContext);

	React.useEffect(() => {
		ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
	}, [location.pathname, location.search]);

	const routes = (language = "") => (
		<Route key={language} path={`/${language}`}>
			<Route path='' element={<Home ref={fullPageRef} />} />
			<Route path='lavori' element={<Category term={`typology`} />} />
			<Route path='clienti' element={<Category term={`client`} />} />
			<Route path=':slug' element={<Page />} />
			<Route path='lavori/:slug' element={<Project />} />
		</Route>
	);

	return (
		<Fragment>
			<Header ref={fullPageRef} />
			<Routes primary={false}>
				{routes()}
				{!!languages?.["available"]?.["length"] &&
					languages["available"].map((language) => routes(language))}
				<Route path='*' element={<NotFound />} />
			</Routes>
		</Fragment>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<DataProvider>
				<VideoProvider>
					<App />
				</VideoProvider>
			</DataProvider>
		</BrowserRouter>
	</React.StrictMode>
);
